<template>
  <v-container fluid class="b-container px-0">
    <v-sheet class="pa-3">
      <Viber class="my-2" />

      <Sms class="my-2" />
    </v-sheet>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import translations from '@/utils/translations/general/settings/billingDashboard';
import Sms from './charges/Sms.vue';
import Viber from './charges/Viber.vue';

export default {
  name: 'BillingDashboardCharges',
  mixins: [translations],
  components: { Sms, Viber },

  data() {
    return {
      tab: 'sms',
    };
  },

  computed: {
    ...mapState(['superUser']),

    lang() {
      return this.$route.params.lang;
    },
  },
};
</script>

<style scoped>
.relative {
  position: relative;
}
</style>
